export default "__VITE_ASSET__4d69f591__"